/* eslint-disable no-param-reassign */
import extend from 'lodash/extend';

import ProductType from 'bundles/payments-common/common/ProductType';
import createCartPromise from 'bundles/payments/promises/createCart';

/**
 * Create a Prepaid Cart. NOTE: Refer to ./createCart for more information.
 * @param {string} id - The productItemId
 * @param {Object} options - Refer to ./createCart
 * @param {Array} options.auxiliaryCartInfo - Refer to ./createCart
 * @returns {Promise.<Object>} ./createCart response.
 */
export default function (id: string, options: $TSFixMe) {
  options = extend(
    {},
    {
      productItems: [
        {
          productType: options.productType || ProductType.SPECIALIZATION,
          productItemId: id,
          productAction: 'Buy',
          cartItemIdToRefund: {},
          metadata: options.metadata || null,
        },
      ],
    },
    options
  );

  return createCartPromise(options);
}
